"use client";

import { useState } from "react";
import { useT } from "@tillix/i18n/react";
import {
  FieldControl,
  FieldError,
  FieldLabel,
  FieldRoot,
} from "@tillix/ui-atoms/field";
import { Input } from "@tillix/ui-atoms/input";
import { Controller, useFormContext } from "react-hook-form";
import { useCardNetworkContext } from "../hooks/cardNetworkContext";

export interface CvvInputProps {
  name?: string;
  id: string;
}

export function CvvInput({ name = "cvv", id }: CvvInputProps) {
  const { control } = useFormContext();
  const { t } = useT();
  const { t: tInputs } = useT("inputs");
  const { cvvSize } = useCardNetworkContext();
  const [isFocused, setIsFocused] = useState(false);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const digits = field.value as string;
        const display =
          isFocused || digits.length === 0 ? digits : "•".repeat(digits.length);

        return (
          <FieldRoot name={field.name}>
            <FieldLabel htmlFor={id}>{t("paymentForm.cvv")}</FieldLabel>
            <FieldControl
              render={(defaultProps) => (
                <Input
                  {...defaultProps}
                  autoComplete="cc-csc"
                  id={id}
                  inputMode="numeric"
                  name={field.name}
                  onBlur={() => {
                    setIsFocused(false);
                    field.onBlur();
                  }}
                  onChange={(e) => {
                    const next = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, cvvSize);
                    field.onChange(next);
                  }}
                  onFocus={() => setIsFocused(true)}
                  placeholder="CVV"
                  ref={field.ref}
                  value={display}
                />
              )}
            />
            <FieldError>
              {fieldState.error ? tInputs("validation.invalidCvv") : undefined}
            </FieldError>
          </FieldRoot>
        );
      }}
    />
  );
}
